















































































import { ManageDuplicateApi } from '@/api/manage-duplicate';
import { Forbidden } from '@/api/responses/forbidden';
import mergeClientDialog from '@/components/data-management/duplicate-clients/client-merge-dialog.vue';
import loading from '@/components/loading.vue';
import layout from '@/layouts/app.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { PartnerPractice } from '@/shared/partner-practice';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

const manageDuplicateApi = new ManageDuplicateApi();

@Component({
    components: {
        layout,
        loading,
        mergeClientDialog,
    },
})
export default class ManageDuplicateClients extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;
    @partnerPracticesModule.Getter('partnerPracticeOriginalSourceTypes') private partnerPracticeOriginalSourceTypes!: (partnerPracticeId: string | null) => Array<ClientOriginalSourceType>;

    @typesModule.Getter('clientOriginalSourceTypeDescription') private clientOriginalSourceTypeDescription!: (originalSourceTypeId: string | null) => string;

    private clients: Array<ClientAccount> = new Array<ClientAccount>();
    private selectedClient: ClientAccount | null = null;
    private loading: boolean = false;
    private selectedPartnerPracticeId: string | null = null;
    private selectedOriginalSourceTypeId: string | null = null;
    private currentPage: number = 1;
    private pageSize: number = 100;
    private emptyText: string = 'Please enter some search filters and click Filter to show duplicate clients';
    private showMergeClientDialog: boolean = false;
    private isManualMerge: boolean = false;
    private clientFields: Array<{}> = [
        { key: 'accountNo', label: 'Account Number' },
        { key: 'name', label: 'Name' },
        { key: 'partnerPractice', label: 'Assigned To' },
        { key: 'originalSource', label: 'Introducer' },
        { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
    ];

    private get totalRows(): number {
        return this.clients.length;
    }

    private get paginationDescription(): string {
        const start = (this.clients.length < 1)
            ? 0
            : ((this.currentPage - 1) * this.pageSize) + 1;

        const end = start + this.pageSize > this.totalRows
            ? this.totalRows
            : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.totalRows.toLocaleString()}`;
    }

    @Watch('selectedPartnerPracticeTypeId')
    private async onSelectedPartnerPracticeTypeIdChanged(): Promise<void> {
        this.selectedOriginalSourceTypeId = null;
    }

    private clientName(client: ClientAccount): string {
        return `${client.firstName != null ? client.firstName.trim() : ''} ${client.lastName != null ? client.lastName.trim() : ''}`;
    }

    private async onLoadClientDuplicatesAsync(): Promise<void> {
        const isValid = await this.$validator.validateAll('partner-practice-select');

        if (!isValid) {
            return;
        }

        this.loading = true;

        try {
            this.emptyText = 'No duplicate clients found matching the search filters';

            this.clients = await manageDuplicateApi.getDuplicateClientsAsync({
                partnerPracticeId: this.partnerPractices.length === 1 ? this.partnerPractices[0].id! : this.selectedPartnerPracticeId,
                originalSourceId: this.selectedOriginalSourceTypeId,
            });
        } catch (e) {
            if (e instanceof (Forbidden)) {
                this.$router.push({ name: 'forbidden' });
            } else {
                this.$snackbar.open({ message: 'Could not load duplicate clients.', type: 'is-danger' });
            }
        }

        this.loading = false;
    }

    private onShowMergeClientDialog(client: ClientAccount): void {
        this.selectedClient = client;
        this.isManualMerge = false;
        this.showMergeClientDialog = true;
    }

    private onShowManualMergeClientDialog() {
        this.selectedClient = null;
        this.isManualMerge = true;
        this.showMergeClientDialog = true;
    }

    private async onCancel(): Promise<void> {
        this.selectedClient = null;
        this.showMergeClientDialog = false;
        await this.onLoadClientDuplicatesAsync();
    }

    private onClearFilters(): void {
        this.selectedPartnerPracticeId = null;
        this.selectedOriginalSourceTypeId = null;
    }

    public async mounted(): Promise<void> {
        this.loading = true;

        const types = [
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
        ];

        await Promise.all(types);

        this.loading = false;
    }
}
